import { Button, Text, View } from '@components/primitives';
import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import React from 'react';
import styles from './style';

interface LoginInfoData {
  hasTwoButtons?: boolean;
}

interface LoginInfo {
  data?: LoginInfoData;
}

export function shouldRenderButtons(
  loginInfo: LoginInfo | undefined,
  onPressPrimary: () => void,
  buttonText: string,
  onPressSecondary?: () => void,
  buttonText2?: string,
) {
  return loginInfo?.data?.hasTwoButtons ? (
    <View style={styles.buttonContainer}>
      <Button
        testID="btnPrimary"
        // height="42px"
        flex={1}
        variant="ghost"
        onPress={onPressPrimary}
        marginRight={5}
        paddingY={scale(8)}
        textVariant="lg-bold"
        textColor={colors.primary.carnation}
        // textStyle={{ flex: 1, borderColor: 'black', borderWidth: 1, paddingVertical: 10 }}
      >
        {buttonText}
      </Button>
      <Button
        paddingY={scale(8)}
        testID="btnSecondary"
        // height="42px"
        flex={1}
        variant="solid"
        onPress={onPressSecondary}
        textColor={colors.neutral.cotton}
        // textStyle={{ flex: 1, borderColor: 'black', borderWidth: 1, paddingVertical: 10 }}
        textVariant="lg-bold">
        {buttonText2}
      </Button>
    </View>
  ) : (
    <View style={[styles.buttonContainer, styles.buttonContainerNarrow]}>
      <Button testID="btnOK" flex={1} variant="solid" onPress={onPressPrimary} paddingY={scale(8)}>
        <Text style={styles.okText}>
          {buttonText}
        </Text>
      </Button>
    </View>
  );
}

export function test() {}
